import {Injectable} from '@angular/core';
import {DayTimeIntervalDTO} from '../api/api';

@Injectable({
  providedIn: 'root'
})
export class DailyHourRangeValidatorService {

  getHourAndMinuteFromTimeString(timeString: string): number[] {
    let [hour, minute] = timeString.split(':').map(x => +x);

    if (!isNaN(hour) && !isNaN(minute)) {
      hour = hour < 24 ? hour : 23;
      minute = minute < 60 ? minute : 59;
    } else {
      hour = 0;
      minute = 0;
    }
    return [hour, minute];
  }

  hasValidIntervals(intervals: DayTimeIntervalDTO[]): boolean {
    if (!intervals || intervals.length === 0) {
      return true;
    }
    if (intervals.length === 1) {
      return this.isSingleTimeslotValid(intervals[0]);
    }
    let result: boolean = true;
    for (const slot of intervals) {
      result = this.isSingleTimeslotValid(slot);
      if (!result) {
        return;
      }
    }
    if (!result) {
      return false;
    }
    // result is true at this point
    for (const [index, outerSlot] of intervals.entries()) {
      result = this.isSlotCollisionFree(outerSlot, intervals.slice(index + 1));
      if (!result) {
        return result;
      }
    }
    return result;
  }

  private isSlotCollisionFree(outerSlot: DayTimeIntervalDTO, intervals: DayTimeIntervalDTO[]): boolean {
    let result: boolean = true;

    for (const innerSlot of intervals) {
      // inner.from = outer.from || inner.till = outer.till
      if (
        outerSlot.fromHour === innerSlot.fromHour && outerSlot.fromMinute === innerSlot.fromMinute ||
        outerSlot.tillHour === innerSlot.tillHour && outerSlot.tillMinute === innerSlot.tillMinute
      ) {
        result = false;
        return result;
      }
      if (
        // inner.from < outer.from < inner.till || outer.from < inner.from < outer.till
        ((innerSlot.fromHour * 3600 + innerSlot.fromMinute * 60) < (outerSlot.fromHour * 3600 + outerSlot.fromMinute * 60) &&
          (outerSlot.fromHour * 3600 + outerSlot.fromMinute * 60) < (innerSlot.tillHour * 3600 + innerSlot.tillMinute * 60)) ||
        (outerSlot.fromHour * 3600 + outerSlot.fromMinute * 60) < (innerSlot.fromHour * 3600 + innerSlot.fromMinute * 60) &&
        (innerSlot.fromHour * 3600 + innerSlot.fromMinute * 60) < (outerSlot.tillHour * 3600 + outerSlot.tillMinute * 60)
      ) {
        result = false;
        return result;
      }
    }
    return result;
  }

  private isSingleTimeslotValid(slot: DayTimeIntervalDTO): boolean {
    // undefined or null
    if (!slot) {
      return false;
    }
    // one value undefined or null
    if (slot.fromHour == null || slot.fromMinute == null || slot.tillHour == null || slot.tillMinute == null) {
      return false;
    }
    // from < till
    return slot.fromHour < slot.tillHour || (slot.fromHour === slot.tillHour && slot.fromMinute < slot.tillMinute);
  }
}
